/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../components/Menu'
import Table from '../../../components/UsersList'

import userIcon from '../../../assets/svg/userIcon.svg'
import { get } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  document.title = 'کاربران'

  const [users, setUsers] = useState()
  const [usersCount, setUsersCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [name, setName] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/users?token=${token}`)
      .then(response => {
        setUsers(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setUsersCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/users?page=${event.selected + 1}&token=${token}`)
      .then(response => {
        setUsers(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setUsersCount(response.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  const searchBtnHandler = () => {
    get(`/api/admin/users/search/${name}?token=${token}`)
    .then(response => {
      setUsers(response.data.data)
      setTotalPage(0)
      setUsersCount(response.data.data.length)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const getAllDataHandler = () => {
    get(`/api/admin/users?token=${token}`)
      .then(response => {
        setUsers(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setUsersCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'user'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={userIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست کاربران
              </div>
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">نام کاربر : </label>
              <input type="text" onChange={e => setName(e.target.value)}/>
              <button onClick={searchBtnHandler} style={{ margin: '0 0 0 1em' }}>جستجو</button>
              <button onClick={getAllDataHandler}>دریافت کل اطلاعات</button>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                تعداد کل‌کاربران
              </div>
              <div className="left">
                {usersCount}
              </div>
            </div>

            <Table data={users}/>
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
